import { z } from 'zod'
import typeguard from '../typeguard'


export interface item {
  id: number
  parent: number
  title: string
  menueId?: number
  brand?: number
  href?: string
  path?: string
  children?: item[]
}

const item: z.ZodType<item> = z.lazy(() => 
  z.object({
    id: z.number(),
    parent: z.number(),
    title: z.string(),
    menueId: z.number().optional(),
    brand: z.number().optional(),
    href: z.string().optional(),
    path: z.string().optional(),
    children: z.array(item).optional(),
  })
)

export const isItem = typeguard<item>(item)


const menuSchema = z.array(item)
export type tMenu = z.infer<typeof menuSchema>
export const isMenu = typeguard<tMenu>(menuSchema)
